import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AttachmentModel, AttachmentAssignmentModel, AttachmentOwnerType, StorageType } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  private apiUrl = '/api/attachments';

  constructor(private http: HttpClient) { }

  /**
   * Získá všechny dostupné soubory (pro výběr existujících)
   */
  getAll(search?: string): Observable<AttachmentModel[]> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<AttachmentModel[]>(this.apiUrl, { params });
  }

  /**
   * Získá soubory přiřazené k entitě
   */
  getByOwner(ownerType: AttachmentOwnerType, ownerId: number): Observable<AttachmentModel[]> {
    return this.http.get<AttachmentModel[]>(`${this.apiUrl}/${ownerType}/${ownerId}`);
  }

  /**
   * Nahraje nový soubor a přiřadí ho k entitě
   */
  upload(ownerType: AttachmentOwnerType, ownerId: number, storageType: StorageType, file: File): Observable<AttachmentAssignmentModel> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<AttachmentAssignmentModel>(`${this.apiUrl}/upload/${ownerType}/${ownerId}/${storageType}`, formData);
  }

  /**
   * Přiřadí existující soubor k entitě
   */
  assign(attachmentId: number, ownerType: AttachmentOwnerType, ownerId: number): Observable<AttachmentAssignmentModel> {
    return this.http.post<AttachmentAssignmentModel>(`${this.apiUrl}/assign/${attachmentId}/${ownerType}/${ownerId}`, {});
  }

  /**
   * Odebere přiřazení souboru od entity
   */
  unassign(assignmentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/unassign/${assignmentId}`);
  }

  /**
   * Smaže soubor a všechna jeho přiřazení
   */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /**
   * Pomocná metoda pro formátování velikosti souboru
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  /**
   * Získá ikonu podle MIME typu
   */
  getFileIcon(mimeType: string): string {
    if (mimeType.startsWith('image/')) return 'pi-image';
    if (mimeType === 'application/pdf') return 'pi-file-pdf';
    if (mimeType.includes('word') || mimeType.includes('document')) return 'pi-file-word';
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'pi-file-excel';
    if (mimeType.includes('zip') || mimeType.includes('archive')) return 'pi-box';
    return 'pi-file';
  }
}
